"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paramsToString = void 0;
const query_string_1 = __importDefault(require("query-string"));
const paramsToString = (params) => {
    if (typeof params !== 'object' && Object.keys(params || {}).length < 1) {
        return '';
    }
    return `&${query_string_1.default.stringify(params || {})}`;
};
exports.paramsToString = paramsToString;
//# sourceMappingURL=utils.js.map